const baseUrl = 'http://sjzs.zhousi.hdlkeji.com/index.php' //测试环境
// const baseUrl = 'http://sjzs.zhousi.hdlkeji.com/index.php' //正式环境
export { baseUrl }